import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';
import { queryClient } from '~/api/client';
import { meQuery } from '~/api/queries';
import { entryPath } from '~/lib/entry';

export const Route = createFileRoute('/')({ component: Splash });

/** Ring-draw splash. Tapping skips it; it moves on by itself after 3 s. */
function Splash() {
  const navigate = useNavigate();
  const next = useCallback(() => {
    void navigate({ to: entryPath(queryClient.getQueryData(meQuery.queryKey)), replace: true });
  }, [navigate]);

  useEffect(() => {
    const t = setTimeout(next, 3000);
    return () => clearTimeout(t);
  }, [next]);

  return (
    <div
      onClick={next}
      className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-4 bg-white"
    >
      <div className="relative h-24 w-24">
        <svg width="96" height="96" viewBox="0 0 96 96" style={{ transform: 'rotate(-90deg)' }}>
          <circle cx="48" cy="48" r="36" fill="none" stroke="#e6f4fc" strokeWidth="14" />
          <circle
            cx="48"
            cy="48"
            r="36"
            fill="none"
            stroke="#0369a1"
            strokeWidth="14"
            strokeLinecap="round"
            style={{
              strokeDasharray: 226.2,
              strokeDashoffset: 226.2,
              animation: 'dash 1.1s cubic-bezier(.6,0,.2,1) .15s forwards',
            }}
          />
        </svg>
        <div
          className="absolute top-1/2 left-1/2 -mt-[9px] -ml-[9px] h-[18px] w-[18px] rounded-full bg-brand"
          style={{ transform: 'scale(0)', animation: 'pop .45s cubic-bezier(.3,1.6,.5,1) 1.05s forwards' }}
        />
      </div>
      <div
        className="font-display text-[32px] font-bold tracking-[-0.03em]"
        style={{ opacity: 0, animation: 'rise .6s ease 1.25s forwards' }}
      >
        hudhuria
      </div>
      <div
        className="text-[14px] text-slate-500"
        style={{ opacity: 0, animation: 'rise .6s ease 1.55s forwards' }}
      >
        Attendance in seconds, not minutes
      </div>
    </div>
  );
}
